module.exports = __webpack_public_path__ + "img/end_btn.95e4227e.png";